import {makeAutoObservable} from "mobx";
import {provider} from "../../Router";
import {navigationStore} from "../NavigationStore";
import {fmsPicklistDetailStore} from "./FmsPicklistDetailStore";

const uuidPattern = /^[0-9a-fA-F]{8}[/-][0-9a-fA-F]{4}[/-][0-9a-fA-F]{4}[/-][0-9a-fA-F]{4}[/-][0-9a-fA-F]{12}$/
const vinPattern = /^((?![IOQ])[A-Z0-9]){17}$/
const fmsPrefix = 'fms:'
const picklistPrefix = `${fmsPrefix}picklist:`
const vrsPrefix = 'vrs:'

class FmsBarcodeScanStore {
    constructor() {
        makeAutoObservable(this)
    }

    async notify(val: string) {
        if (val.startsWith(picklistPrefix)) {
            const uuidCandidate = val.substring(picklistPrefix.length)
            if (uuidPattern.test(uuidCandidate)) {
                return provider.router.navigate(`/fms/picklist/${uuidCandidate}`)
            }
            return
        }

        if (
            navigationStore.activePath.startsWith("/fms/picklist/") &&
            val.startsWith(vrsPrefix)
        ) {
            const documentIdCandidate = val.substring(vrsPrefix.length)
            return fmsPicklistDetailStore.lastScan(documentIdCandidate)
        }

        if (
            navigationStore.activePath.startsWith("/fms/picklist/") &&
            val.endsWith('1') &&
            vinPattern.test(val.substring(0, val.length - 1))
        ) {
            const vin = val.substring(0, val.length - 1)
            const documentId = fmsPicklistDetailStore.documentIdByVin(vin)
            return fmsPicklistDetailStore.lastScan(documentId!)
        }

        // else we consider val to be documentId
        if (
            navigationStore.activePath.startsWith("/fms/picklist/")
        ) {
            const documentIdCandidate = val
            return fmsPicklistDetailStore.lastScan(documentIdCandidate)
        }
    }
}

const fmsBarcodeScanStore = new FmsBarcodeScanStore()

export {
    fmsBarcodeScanStore
}
